import React, { useEffect } from 'react';
import {
  ArrowLeft,
  Bell,
  CheckCircle2,
  Globe,
  HelpCircle,
  KeyRound,
  ListChecks,
  MessageSquare,
  Send,
  ShieldCheck,
  Webhook
} from 'lucide-react';

const SITE_URL = 'https://fiscal.mateusemth.dev';

const workflowPayload = `{
  "source": "monitor-fiscal",
  "developed_by": "Monitor Fiscal",
  "monitor_fiscal_url": "https://fiscal.mateusemth.dev",
  "timestamp": "2026-05-24T21:00:00.000Z",
  "event": "service_availability",
  "topic": "service_availability:nfce",
  "portal": "nfce",
  "portalName": "NFC-e SVRS",
  "servico": "Autorização NFC-e",
  "status": "Instável",
  "status_raw": "slow",
  "status_label": "Lento",
  "severity": "degraded",
  "uf": "MG",
  "tempo": 3500,
  "tempo_ms": 3500,
  "checkedAt": "2026-05-24T21:00:00.000Z",
  "checkedAtBr": "24/05/2026, 21:00:00",
  "statusUrl": "https://dfe-portal.svrs.rs.gov.br/Nfce/Documentos",
  "fonte": "Portal NFC-e SVRS",
  "fonte_oficial": "https://dfe-portal.svrs.rs.gov.br/Nfce/Documentos",
  "officialSource": {
    "type": "portal_oficial",
    "label": "Portal NFC-e SVRS",
    "url": "https://dfe-portal.svrs.rs.gov.br/Nfce/Documentos"
  },
  "details": null,
  "data": {
    "portalSlug": "nfce",
    "portalName": "NFC-e SVRS",
    "sistema": "NFCE",
    "servico": "Autorização NFC-e",
    "available": false,
    "status": "slow",
    "statusCode": 2,
    "label": "Lento",
    "severity": "degraded",
    "uf": "MG",
    "responseTimeMs": 3500,
    "title": null,
    "message": null,
    "statusUrl": "https://dfe-portal.svrs.rs.gov.br/Nfce/Documentos",
    "officialSourceUrl": "https://dfe-portal.svrs.rs.gov.br/Nfce/Documentos",
    "officialSourceLabel": "Portal NFC-e SVRS",
    "checkedAt": "2026-05-24T21:00:00.000Z",
    "details": null,
    "contingency": null,
    "normalizedStatus": "Instável",
    "statusRaw": "slow",
    "statusLabel": "Lento",
    "checkedAtBr": "24/05/2026, 21:00:00"
  }
}`;

const documentPayload = `{
  "source": "monitor-fiscal",
  "developed_by": "Monitor Fiscal",
  "monitor_fiscal_url": "https://fiscal.mateusemth.dev",
  "timestamp": "2026-05-24T21:00:00.000Z",
  "event": "new_document",
  "topic": "new_document:nfe",
  "portal": "nfe",
  "servico": "NFE",
  "fonte": "NF-e (Portal Nacional)",
  "fonte_oficial": "https://www.nfe.fazenda.gov.br/portal/exemplo",
  "officialSource": {
    "type": "portal_oficial",
    "label": "NF-e (Portal Nacional)",
    "url": "https://www.nfe.fazenda.gov.br/portal/exemplo"
  },
  "data": {
    "id": 321,
    "portalSlug": "nfe",
    "portalName": "NF-e (Portal Nacional)",
    "sistema": "NFE",
    "tipo": "Documentos vigentes",
    "nome": "NT 2026.001 v1.00",
    "description": "Descrição do documento, quando disponível.",
    "url": "https://fiscal.mateusemth.dev/d/abc123",
    "officialSourceUrl": "https://www.nfe.fazenda.gov.br/portal/exemplo",
    "data": "24/05/2026",
    "rawPayload": null
  }
}`;

const workflowRegistrationPayload = `{
  "url": "https://hooks.slack.com/triggers/T00000000/000000000000/XXXXXXXXXXXXXXXXXXXXXXXX",
  "name": "Alertas SEFAZ no Slack",
  "channelType": "generic",
  "topics": [
    "service_availability:nfce",
    "service_availability:nfe"
  ]
}`;

const incomingRegistrationPayload = `{
  "url": "https://hooks.slack.com/services/T00000000/B00000000/XXXXXXXXXXXXXXXXXXXXXXXX",
  "name": "Canal SEFAZ",
  "channelType": "slack",
  "topics": [
    "service_availability:nfce",
    "service_availability:nfe"
  ]
}`;

const monitorSteps = [
  ['Abra as ações do sininho', 'Na área de status ou notificações, localize o ícone de sininho. Passe o mouse ou clique nele para abrir as ações rápidas.'],
  ['Clique no webhook roxo/índigo', 'Clique no ícone de Webhook, com tooltip Configurar Webhook. A janela Configurar Webhooks será aberta.'],
  ['Preencha URL e nome', 'Cole a URL gerada no Slack em URL do Webhook e informe um nome amigável, por exemplo Alertas SEFAZ - Suporte.'],
  ['Escolha Slack ou Genérico', 'Se a URL contém /triggers/, selecione Webhook Genérico. Se contém /services/, selecione Slack.'],
  ['Selecione os tópicos', 'Para alertas de queda e normalização, selecione tópicos de Disponibilidade. Para publicações, use Novos Documentos.'],
  ['Salve e teste', 'Clique em Adicionar Webhook. Depois, em Webhooks Configurados, clique no botão de envio para testar.']
];

const workflowSteps = [
  'Abra o Slack e acesse Automations ou Automações.',
  'Entre em Workflow Builder e clique em Create workflow.',
  'Escolha iniciar o workflow from a webhook ou a partir de um webhook.',
  'Crie variáveis de texto: status, status_raw, severity, uf, tempo, tempo_ms, servico, portal, portalName, checkedAtBr, fonte e fonte_oficial.',
  'Copie a URL gerada pelo Slack. Ela começa com https://hooks.slack.com/triggers/...',
  'No Monitor Fiscal, cadastre essa URL como Webhook Genérico.',
  'No Slack, crie condições usando status igual a Inoperante, Instável ou Operacional.',
  'Publique o workflow e teste pelo botão de envio em Webhooks Configurados.'
];

const incomingSteps = [
  'Acesse https://api.slack.com/apps.',
  'Clique em Create New App e escolha From scratch.',
  'Informe um nome, por exemplo Monitor Fiscal, e selecione o workspace.',
  'No menu do app, clique em Incoming Webhooks.',
  'Ative Activate Incoming Webhooks.',
  'Clique em Add New Webhook to Workspace.',
  'Escolha o canal que receberá as mensagens e clique em Authorize.',
  'Copie a URL gerada. Ela começa com https://hooks.slack.com/services/...',
  'No Monitor Fiscal, cadastre essa URL como Slack.'
];

const serviceTopics = [
  'service_availability:nfe',
  'service_availability:nfce',
  'service_availability:mdfe',
  'service_availability:cte',
  'service_availability:cte_svrs',
  'service_availability:nfe_svrs'
];

const documentTopics = [
  'new_document:nfe',
  'new_document:nfce',
  'new_document:mdfe',
  'new_document:cte',
  'new_document:cte_svrs',
  'new_document:nfe_svrs'
];

const workflowFields = [
  ['status', 'Inoperante', 'Ramificação principal do Slack'],
  ['status_raw', 'timeout', 'Valor técnico original/normalizado'],
  ['severity', 'outage', 'Severidade técnica'],
  ['uf', 'MG', 'Estado afetado, quando existir'],
  ['tempo', '3500', 'Tempo em milissegundos'],
  ['tempo_ms', '3500', 'Mesmo valor de tempo'],
  ['servico', 'Autorização NFC-e', 'Serviço monitorado'],
  ['portal', 'nfce', 'Identificador do portal'],
  ['portalName', 'NFC-e SVRS', 'Nome amigável do portal'],
  ['checkedAtBr', '24/05/2026, 21:00:00', 'Data/hora formatada'],
  ['fonte', 'Portal NFC-e SVRS', 'Nome da fonte oficial'],
  ['fonte_oficial', 'https://...', 'URL do portal oficial']
];

const servicePayloadProperties = [
  ['source', 'string', 'monitor-fiscal', 'Origem do webhook genérico.'],
  ['developed_by', 'string', 'Monitor Fiscal', 'Identificação do emissor.'],
  ['monitor_fiscal_url', 'string', 'https://fiscal.mateusemth.dev', 'URL pública do Monitor Fiscal.'],
  ['timestamp', 'string ISO', 'Data/hora do envio', 'Gerado no momento do disparo.'],
  ['event', 'string', 'service_availability', 'Tipo do evento.'],
  ['topic', 'string', 'service_availability:*', 'Tópico assinado no Monitor Fiscal.'],
  ['portal', 'string', 'nfe, nfce, mdfe, cte, cte_svrs, nfe_svrs', 'Identificador do portal.'],
  ['portalName', 'string', 'Nome amigável do portal', 'Exemplo: NFC-e SVRS.'],
  ['servico', 'string', 'Nome do serviço monitorado', 'Exemplo: Autorização NFC-e.'],
  ['status', 'string', 'Operacional, Instável, Inoperante, Desconhecido', 'Campo principal para ramificações do Slack.'],
  ['status_raw', 'string/null', 'Veja tabela de status_raw', 'Valor técnico normalizado.'],
  ['status_label', 'string', 'Normal, Lento, Muito lento, Timeout, Erro, Indisponível, Desconhecido', 'Texto amigável do status.'],
  ['severity', 'string', 'operational, degraded, outage, unknown', 'Severidade técnica.'],
  ['uf', 'string/null', 'Sigla da UF', 'Pode vir null quando o portal não separa por UF.'],
  ['tempo', 'number/null', 'Milissegundos', 'Mesmo valor de tempo_ms.'],
  ['tempo_ms', 'number/null', 'Milissegundos', 'Tempo de resposta em ms.'],
  ['checkedAt', 'string/null', 'Data ISO', 'Data/hora original da verificação.'],
  ['checkedAtBr', 'string/null', 'DD/MM/AAAA, HH:MM:SS', 'Data/hora formatada em português do Brasil.'],
  ['statusUrl', 'string/null', 'URL', 'Página de status/consulta usada como referência.'],
  ['fonte', 'string', 'Nome da fonte oficial', 'Exemplo: Portal NFC-e SVRS.'],
  ['fonte_oficial', 'string/null', 'URL', 'Link do portal oficial consultado.'],
  ['officialSource', 'object', '{ type, label, url }', 'Objeto com a fonte oficial.'],
  ['details', 'string/null', 'Texto livre', 'Detalhes adicionais quando a origem fornece.'],
  ['data', 'object', 'Objeto completo do serviço', 'Campos técnicos usados para gerar o payload.']
];

const serviceDataProperties = [
  ['portalSlug', 'string', 'nfe, nfce, mdfe, cte, cte_svrs, nfe_svrs', 'Mesmo identificador de portal.'],
  ['portalName', 'string', 'Nome amigável do portal', 'Exemplo: NFC-e SVRS.'],
  ['sistema', 'string', 'NFE, NFCE, MDFE, CTE', 'Sistema fiscal.'],
  ['servico', 'string', 'Serviço monitorado', 'Nome do serviço fiscal.'],
  ['available', 'boolean/null', 'true, false, null', 'Disponibilidade quando a origem informa booleano.'],
  ['status', 'string/null', 'Valor bruto recebido/normalizado', 'Pode ser textual ou código convertido.'],
  ['statusCode', 'number/string/null', '1, 2, 3, 4, 5', 'Código numérico quando a fonte usa códigos.'],
  ['label', 'string/null', 'Texto amigável da origem', 'Exemplo: Lento.'],
  ['severity', 'string/null', 'operational, degraded, outage, unknown', 'Severidade técnica.'],
  ['uf', 'string/null', 'Sigla da UF', 'Exemplo: SP.'],
  ['responseTimeMs', 'number/null', 'Milissegundos', 'Tempo de resposta original.'],
  ['title', 'string/null', 'Texto livre', 'Título customizado quando informado.'],
  ['message', 'string/null', 'Texto livre', 'Mensagem customizada quando informada.'],
  ['statusUrl', 'string/null', 'URL', 'Página de status.'],
  ['officialSourceUrl', 'string/null', 'URL', 'Link oficial da fonte.'],
  ['officialSourceLabel', 'string', 'Nome da fonte', 'Nome amigável da fonte.'],
  ['checkedAt', 'string/null', 'Data ISO', 'Data/hora original.'],
  ['details', 'string/null', 'Texto livre', 'Detalhes adicionais.'],
  ['contingency', 'object/null', 'Dados de contingência', 'Pode incluir contingência ativa ou agendada.'],
  ['normalizedStatus', 'string', 'Operacional, Instável, Inoperante, Desconhecido', 'Mesmo valor de status no topo.'],
  ['statusRaw', 'string/null', 'Veja tabela de status_raw', 'Mesmo valor de status_raw.'],
  ['statusLabel', 'string', 'Texto amigável', 'Mesmo valor de status_label.'],
  ['checkedAtBr', 'string/null', 'Data/hora BR', 'Mesmo valor de checkedAtBr no topo.']
];

const documentPayloadProperties = [
  ['source', 'string', 'monitor-fiscal', 'Origem do webhook genérico.'],
  ['developed_by', 'string', 'Monitor Fiscal', 'Identificação do emissor.'],
  ['monitor_fiscal_url', 'string', 'https://fiscal.mateusemth.dev', 'URL pública do Monitor Fiscal.'],
  ['timestamp', 'string ISO', 'Data/hora do envio', 'Gerado no momento do disparo.'],
  ['event', 'string', 'new_document', 'Tipo do evento.'],
  ['topic', 'string', 'new_document:*', 'Tópico assinado no Monitor Fiscal.'],
  ['portal', 'string', 'nfe, nfce, mdfe, cte, cte_svrs, nfe_svrs', 'Identificador do portal.'],
  ['servico', 'string', 'Sistema ou portal', 'Exemplo: NFE.'],
  ['fonte', 'string', 'Nome da fonte oficial', 'Nome do portal oficial.'],
  ['fonte_oficial', 'string/null', 'URL', 'Link oficial da publicação original.'],
  ['officialSource', 'object', '{ type, label, url }', 'Objeto com a fonte oficial.'],
  ['data', 'object', 'Objeto completo do documento', 'Dados do documento publicado.']
];

const documentDataProperties = [
  ['id', 'number/null', 'ID interno do documento', 'Pode vir null em payload manual.'],
  ['portalSlug', 'string', 'nfe, nfce, mdfe, cte, cte_svrs, nfe_svrs', 'Identificador do portal.'],
  ['portalName', 'string', 'Nome amigável do portal', 'Exemplo: NF-e (Portal Nacional).'],
  ['sistema', 'string', 'NFE, NFCE, MDFE, CTE', 'Sistema fiscal.'],
  ['tipo', 'string', 'Tipo/categoria do documento', 'Exemplo: Documentos vigentes.'],
  ['nome', 'string', 'Nome do documento', 'Exemplo: NT 2026.001 v1.00.'],
  ['description', 'string/null', 'Texto descritivo', 'Descrição quando disponível.'],
  ['url', 'string', 'URL pública encurtada', 'Link público do Monitor Fiscal para abrir o documento.'],
  ['officialSourceUrl', 'string/null', 'URL', 'Link oficial original.'],
  ['data', 'string/null', 'DD/MM/AAAA', 'Data do documento/publicação.'],
  ['rawPayload', 'object/null', 'Payload bruto', 'Dados originais preservados quando existirem.']
];

const statusValueRows = [
  ['Operacional', 'Serviço normal, disponível, online ou restabelecido.'],
  ['Instável', 'Lentidão, degradação, instabilidade, manutenção ou contingência agendada.'],
  ['Inoperante', 'Timeout, erro, indisponibilidade, offline ou serviço fora do ar.'],
  ['Desconhecido', 'A origem retornou algo que não foi reconhecido.']
];

const rawStatusRows = [
  ['Operacional', 'operational, normal, available, online, operacional, disponivel'],
  ['Instável', 'scheduled, unstable, degraded, slow, very_slow, instavel, lento'],
  ['Inoperante', 'outage, offline, unavailable, timeout, error, inoperante, indisponivel'],
  ['Desconhecido', 'Valor original não reconhecido ou null']
];

const severityRows = [
  ['operational', 'Serviço operacional.'],
  ['degraded', 'Serviço degradado, lento ou instável.'],
  ['outage', 'Serviço indisponível ou com erro.'],
  ['unknown', 'Severidade desconhecida.']
];

const statusCodeRows = [
  ['1', 'Operacional', 'normal', 'Normal', 'operational'],
  ['2', 'Instável', 'slow', 'Lento', 'degraded'],
  ['3', 'Instável', 'very_slow', 'Muito lento', 'degraded'],
  ['4', 'Inoperante', 'timeout', 'Timeout', 'outage'],
  ['5', 'Inoperante', 'error', 'Erro', 'outage']
];

const channelTypeRows = [
  ['generic', 'Workflow Builder do Slack, Zapier, Make ou qualquer webhook que precise receber JSON simples.'],
  ['slack', 'Incoming Webhook simples do Slack, com mensagem pronta em Block Kit.'],
  ['discord', 'Webhook do Discord, com mensagem em embed.']
];

const auxiliaryEventRows = [
  ['setup_success', 'Enviado após cadastrar o webhook, para confirmar que a integração foi conectada.'],
  ['test_notification', 'Enviado ao clicar no botão de teste do webhook.']
];

const statusMessages = [
  ['Inoperante', '🔴 SEFAZ INOPERANTE\nUF: {uf}\nServiço: {servico}\nStatus: {status}\nTempo de resposta: {tempo}ms\nFonte oficial: {fonte_oficial}'],
  ['Instável', '🟡 LENTIDÃO/INSTABILIDADE NA SEFAZ\nUF: {uf}\nServiço: {servico}\nStatus: {status}\nTempo de resposta: {tempo}ms\nFonte oficial: {fonte_oficial}'],
  ['Operacional', '🟢 SEFAZ NORMALIZADA\nUF: {uf}\nServiço: {servico}\nStatus: {status}\nVerificado em: {checkedAtBr}\nFonte oficial: {fonte_oficial}']
];

const troubleshootingItems = [
  ['Não aparece a opção de webhook no Workflow Builder', 'Peça para um owner/admin liberar criação de workflows com webhooks. O Slack permite restringir essa opção por política do workspace.'],
  ['O workflow executa, mas as variáveis chegam vazias', 'Confirme se o webhook foi cadastrado como Webhook Genérico, se os nomes das variáveis estão iguais aos campos do payload e se elas estão no topo do JSON.'],
  ['A mensagem chega duplicada ou com atraso', 'Confira quantos webhooks estão cadastrados para o mesmo tópico. No Slack Workflow Builder, considere também o limite de uma requisição por segundo.'],
  ['Preciso mostrar a fonte oficial do dado', 'Use a variável {fonte_oficial}. Ela aponta para o portal oficial consultado, como SEFAZ, SVRS ou TecnoSpeed.']
];

function updateMeta(selector, attribute, value) {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
}

function CodeBlock({ children }) {
  return (
    <pre className="overflow-x-auto rounded-2xl border border-gray-800 bg-gray-950 p-4 text-xs leading-6 text-gray-100 shadow-xl shadow-gray-950/10">
      <code>{children}</code>
    </pre>
  );
}

function Step({ number, title, children }) {
  return (
    <article className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm dark:border-gray-800 dark:bg-gray-900">
      <div className="flex gap-4">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-xs font-black text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300">
          {number}
        </span>
        <div className="min-w-0">
          <h3 className="text-base font-black text-gray-950 dark:text-white">{title}</h3>
          <div className="mt-2 text-sm leading-7 text-gray-600 dark:text-gray-300">
            {children}
          </div>
        </div>
      </div>
    </article>
  );
}

function SectionHeader({ eyebrow, title, children }) {
  return (
    <div className="mb-5">
      <p className="text-[10px] font-black uppercase tracking-widest text-indigo-700 dark:text-indigo-300">{eyebrow}</p>
      <h2 className="mt-2 text-2xl font-black text-gray-950 dark:text-white">{title}</h2>
      {children ? <p className="mt-3 max-w-3xl text-sm leading-7 text-gray-600 dark:text-gray-300">{children}</p> : null}
    </div>
  );
}

function SimpleStepList({ items }) {
  return (
    <ol className="list-decimal space-y-2 pl-5 text-sm leading-7 text-gray-600 dark:text-gray-300">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ol>
  );
}

function TopicList({ title, topics }) {
  return (
    <article className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm dark:border-gray-800 dark:bg-gray-900">
      <h3 className="text-sm font-black uppercase tracking-widest text-gray-950 dark:text-white">{title}</h3>
      <div className="mt-4 grid gap-2">
        {topics.map((topic) => (
          <code key={topic} className="rounded-lg border border-indigo-100 bg-indigo-50 px-3 py-2 text-xs font-bold text-indigo-800 dark:border-indigo-900/40 dark:bg-indigo-950/40 dark:text-indigo-200">
            {topic}
          </code>
        ))}
      </div>
    </article>
  );
}

function FieldTable() {
  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-gray-800 dark:bg-gray-900">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="bg-indigo-50 text-[10px] font-black uppercase tracking-widest text-indigo-900 dark:bg-indigo-950/40 dark:text-indigo-200">
            <tr>
              <th className="px-4 py-3">Campo</th>
              <th className="px-4 py-3">Exemplo</th>
              <th className="px-4 py-3">Uso</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 text-gray-600 dark:divide-gray-800 dark:text-gray-300">
            {workflowFields.map(([field, example, usage]) => (
              <tr key={field} className="odd:bg-white even:bg-gray-50 dark:odd:bg-gray-900 dark:even:bg-gray-950/50">
                <td className="px-4 py-3"><code>{field}</code></td>
                <td className="px-4 py-3"><code>{example}</code></td>
                <td className="px-4 py-3">{usage}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function PropertyTable({ rows }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-gray-800 dark:bg-gray-900">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[760px] text-left text-sm">
          <thead className="bg-indigo-50 text-[10px] font-black uppercase tracking-widest text-indigo-900 dark:bg-indigo-950/40 dark:text-indigo-200">
            <tr>
              <th className="px-4 py-3">Campo</th>
              <th className="px-4 py-3">Tipo</th>
              <th className="px-4 py-3">Valores possíveis</th>
              <th className="px-4 py-3">Observação</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 text-gray-600 dark:divide-gray-800 dark:text-gray-300">
            {rows.map(([field, type, values, note]) => (
              <tr key={`${field}-${type}`} className="odd:bg-white even:bg-gray-50 dark:odd:bg-gray-900 dark:even:bg-gray-950/50">
                <td className="px-4 py-3"><code>{field}</code></td>
                <td className="px-4 py-3">{type}</td>
                <td className="px-4 py-3">{values}</td>
                <td className="px-4 py-3">{note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ValueTable({ headers, rows }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-gray-800 dark:bg-gray-900">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[520px] text-left text-sm">
          <thead className="bg-gray-50 text-[10px] font-black uppercase tracking-widest text-gray-700 dark:bg-gray-950/70 dark:text-gray-200">
            <tr>
              {headers.map((header) => (
                <th key={header} className="px-4 py-3">{header}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 text-gray-600 dark:divide-gray-800 dark:text-gray-300">
            {rows.map((row) => (
              <tr key={row.join('-')} className="odd:bg-white even:bg-gray-50 dark:odd:bg-gray-900 dark:even:bg-gray-950/50">
                {row.map((cell, index) => (
                  <td key={`${row[0]}-${index}`} className="px-4 py-3">
                    {index === 0 ? <code>{cell}</code> : cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function InfoTile({ icon: Icon, title, children, tone = 'indigo' }) {
  const tones = {
    indigo: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
    emerald: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
    amber: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
  };

  return (
    <article className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm dark:border-gray-800 dark:bg-gray-900">
      <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${tones[tone]}`}>
        <Icon className="h-5 w-5" />
      </div>
      <h2 className="mt-4 text-sm font-black uppercase tracking-widest text-gray-950 dark:text-white">{title}</h2>
      <p className="mt-2 text-sm leading-7 text-gray-600 dark:text-gray-300">{children}</p>
    </article>
  );
}

export default function SlackWebhookGuidePage() {
  useEffect(() => {
    const title = 'Configurar Slack Webhook para alertas SEFAZ - Monitor Fiscal';
    const description = 'Passo a passo para configurar alertas SEFAZ do Monitor Fiscal no Slack com Workflow Builder, Incoming Webhook, status, UF, tempo e fonte oficial.';
    const canonicalUrl = `${SITE_URL}/configurar-slack-webhook`;

    document.title = title;
    updateMeta('meta[name="description"]', 'content', description);
    updateMeta('link[rel="canonical"]', 'href', canonicalUrl);
    updateMeta('meta[property="og:title"]', 'content', title);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[property="og:url"]', 'content', canonicalUrl);
    updateMeta('meta[name="twitter:title"]', 'content', title);
    updateMeta('meta[name="twitter:description"]', 'content', description);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900 dark:bg-gray-950 dark:text-gray-100">
      <header className="border-b border-gray-200 bg-white/95 backdrop-blur dark:border-gray-800 dark:bg-gray-950/95">
        <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between lg:px-6">
          <a href="/" className="flex items-center gap-3">
            <img src="/icon-master.png" alt="" aria-hidden="true" className="h-10 w-10 rounded-xl object-contain" />
            <div>
              <p className="text-sm font-black uppercase text-gray-950 dark:text-white">Monitor Fiscal</p>
              <p className="text-xs font-bold text-gray-500 dark:text-gray-400">Guia Slack Webhook</p>
            </div>
          </a>
          <a href="/" className="inline-flex h-10 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-4 text-[11px] font-black uppercase tracking-widest text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800">
            <ArrowLeft className="h-4 w-4" />
            Voltar ao monitor
          </a>
        </div>
      </header>

      <main>
        <section className="border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-950">
          <div className="mx-auto grid max-w-6xl gap-8 px-4 py-10 lg:grid-cols-[minmax(0,1fr)_22rem] lg:px-6 lg:py-14">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-indigo-200 bg-indigo-50 px-3 py-1 text-[10px] font-black uppercase tracking-widest text-indigo-700 dark:border-indigo-900/60 dark:bg-indigo-950 dark:text-indigo-300">
                <Webhook className="h-3.5 w-3.5" />
                Integração Slack
              </div>
              <h1 className="mt-5 max-w-4xl text-3xl font-black leading-tight text-gray-950 dark:text-white sm:text-5xl">
                Configure alertas SEFAZ no Slack com webhooks do Monitor Fiscal
              </h1>
              <p className="mt-5 max-w-3xl text-base leading-8 text-gray-600 dark:text-gray-300">
                Este guia mostra como gerar a URL no Slack, cadastrar no sininho do Monitor Fiscal, escolher entre Slack e Webhook Genérico, testar o envio e usar variáveis como status, UF, tempo e fonte oficial.
              </p>
              <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                <a href="#monitor-fiscal" className="inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-indigo-600 px-4 text-[11px] font-black uppercase tracking-widest text-white transition-colors hover:bg-indigo-700">
                  Ver cadastro no Monitor
                  <Bell className="h-4 w-4" />
                </a>
                <a href="#workflow-builder" className="inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-4 text-[11px] font-black uppercase tracking-widest text-gray-800 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:hover:bg-gray-800">
                  Ver Workflow Builder
                  <ListChecks className="h-4 w-4" />
                </a>
              </div>
            </div>

            <aside className="self-start rounded-2xl border border-gray-200 bg-gray-50 p-5 dark:border-gray-800 dark:bg-gray-900">
              <p className="text-[10px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400">Escolha rápida</p>
              <div className="mt-4 space-y-3">
                <div className="rounded-xl border border-indigo-200 bg-white p-3 dark:border-indigo-900/50 dark:bg-gray-950">
                  <p className="text-xs font-black text-indigo-700 dark:text-indigo-300">URL /triggers/</p>
                  <p className="mt-1 text-xs leading-5 text-gray-600 dark:text-gray-300">Use Webhook Genérico para Workflow Builder e ramificações.</p>
                </div>
                <div className="rounded-xl border border-emerald-200 bg-white p-3 dark:border-emerald-900/50 dark:bg-gray-950">
                  <p className="text-xs font-black text-emerald-700 dark:text-emerald-300">URL /services/</p>
                  <p className="mt-1 text-xs leading-5 text-gray-600 dark:text-gray-300">Use Slack para mensagem pronta no canal.</p>
                </div>
              </div>
            </aside>
          </div>
        </section>

        <section className="mx-auto grid max-w-6xl gap-4 px-4 py-8 md:grid-cols-3 lg:px-6">
          <InfoTile icon={Globe} title="Workflow Builder">Crie condições como status igual a Inoperante, Instável ou Operacional usando Webhook Genérico.</InfoTile>
          <InfoTile icon={Send} title="Teste pelo painel" tone="emerald">Usuário final pode testar se estiver usando API Key com escopo notifications.</InfoTile>
          <InfoTile icon={KeyRound} title="Permissão" tone="amber">Sem o escopo notifications, o cadastro e o teste retornam erro de permissão.</InfoTile>
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <SectionHeader eyebrow="Antes de começar" title="O que você precisa ter em mãos">
              Separe as permissões no Slack e a chave do Monitor Fiscal antes de iniciar. Isso evita chegar no final do fluxo e descobrir que faltou escopo ou liberação do workspace.
            </SectionHeader>
            <div className="grid gap-3 md:grid-cols-2">
              {[
                'Permissão para criar workflows ou apps no workspace Slack.',
                'Um canal de destino, por exemplo #sefaz-instabilidades.',
                'Acesso ao Monitor Fiscal para cadastrar o webhook pelo sininho.',
                'API Key do Monitor Fiscal com escopo notifications, caso você não esteja usando acesso administrativo.',
                'URL /triggers/ para Workflow Builder ou /services/ para Incoming Webhook simples.',
                'Tópicos de interesse definidos: Disponibilidade ou Novos Documentos.'
              ].map((item) => (
                <div key={item} className="flex gap-3 rounded-xl border border-gray-100 bg-gray-50 p-3 dark:border-gray-800 dark:bg-gray-950/50">
                  <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-300" />
                  <p className="text-sm leading-6 text-gray-600 dark:text-gray-300">{item}</p>
                </div>
              ))}
            </div>
            <div className="mt-6 grid gap-4 lg:grid-cols-2">
              <div className="rounded-2xl border border-gray-100 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-950/50">
                <h3 className="text-sm font-black text-gray-950 dark:text-white">Observações importantes do Slack</h3>
                <ul className="mt-3 list-disc space-y-2 pl-5 text-sm leading-6 text-gray-600 dark:text-gray-300">
                  <li>Workflows iniciados por webhook ficam disponíveis em planos pagos do Slack.</li>
                  <li>Admins e owners podem restringir quem cria workflows com webhooks.</li>
                  <li>O Workflow Builder usa variáveis no corpo da requisição e não aceita variáveis vindas de JSON aninhado.</li>
                  <li>A URL do Workflow Builder começa com <code>https://hooks.slack.com/triggers/...</code>.</li>
                  <li>A URL de Incoming Webhook simples começa com <code>https://hooks.slack.com/services/...</code>.</li>
                </ul>
              </div>
              <div className="rounded-2xl border border-gray-100 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-950/50">
                <h3 className="text-sm font-black text-gray-950 dark:text-white">Referências oficiais</h3>
                <div className="mt-3 grid gap-2 text-sm leading-6">
                  <a className="font-bold text-indigo-600 hover:underline dark:text-indigo-300" href="https://slack.com/help/articles/360041352714-Build-a-workflow--Create-a-workflow-that-starts-outside-of-Slack" target="_blank" rel="noopener noreferrer">Workflow Builder com webhook</a>
                  <a className="font-bold text-indigo-600 hover:underline dark:text-indigo-300" href="https://docs.slack.dev/messaging/sending-messages-using-incoming-webhooks/" target="_blank" rel="noopener noreferrer">Incoming Webhooks</a>
                  <a className="font-bold text-indigo-600 hover:underline dark:text-indigo-300" href="https://docs.slack.dev/tools/deno-slack-sdk/guides/creating-webhook-triggers/" target="_blank" rel="noopener noreferrer">Webhook triggers no Slack Developer Docs</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="monitor-fiscal" className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <SectionHeader eyebrow="Dentro do Monitor Fiscal" title="Como chegar no cadastro pelo sininho">
              Depois de gerar a URL no Slack, volte ao Monitor Fiscal e cadastre o canal de notificação.
            </SectionHeader>
            <div className="mt-6 grid gap-4 md:grid-cols-2">
              {monitorSteps.map(([title, body], index) => (
                <Step key={title} number={index + 1} title={title}>{body}</Step>
              ))}
            </div>
            <div className="mt-6 rounded-2xl border border-amber-200 bg-amber-50 p-5 text-sm leading-7 text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/20 dark:text-amber-100">
              <p className="font-black">Caminho pelo painel administrativo</p>
              <p className="mt-2">
                Se você estiver usando a área administrativa, abra o painel de administração, acesse a aba Webhooks,
                use o formulário Novo Canal de Notificação, cole a URL, escolha Slack ou Webhook Genérico,
                selecione os tópicos e clique em Adicionar Webhook.
              </p>
            </div>
          </div>
        </section>

        <section id="workflow-builder" className="mx-auto grid max-w-6xl gap-4 px-4 pb-8 lg:grid-cols-2 lg:px-6">
          <article className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <SectionHeader eyebrow="Opção A" title="Workflow Builder com variáveis">
              Use quando você quer criar regras no Slack e montar mensagens diferentes por status.
            </SectionHeader>
            <SimpleStepList items={workflowSteps} />
            <div className="mt-5">
              <p className="mb-3 text-sm font-black text-gray-950 dark:text-white">Cadastro no Monitor Fiscal</p>
              <CodeBlock>{workflowRegistrationPayload}</CodeBlock>
              <p className="mt-3 text-sm leading-7 text-gray-600 dark:text-gray-300">
                Ponto principal: para Workflow Builder, use <code>channelType: "generic"</code>.
                Não use <code>channelType: "slack"</code> neste caso, porque o Slack precisa receber JSON simples com variáveis no topo.
              </p>
            </div>
          </article>

          <article className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <SectionHeader eyebrow="Opção B" title="Incoming Webhook simples">
              Use quando você só quer receber uma mensagem pronta no canal, sem ramificações.
            </SectionHeader>
            <SimpleStepList items={incomingSteps} />
            <div className="mt-5">
              <p className="mb-3 text-sm font-black text-gray-950 dark:text-white">Cadastro no Monitor Fiscal</p>
              <CodeBlock>{incomingRegistrationPayload}</CodeBlock>
              <p className="mt-3 text-sm leading-7 text-gray-600 dark:text-gray-300">
                Neste modo, o Monitor Fiscal monta a mensagem pronta e envia para o Slack. Você não precisa criar variáveis no Workflow Builder.
              </p>
            </div>
          </article>
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <SectionHeader eyebrow="Qual tipo escolher?" title="A URL do Slack indica o tipo correto">
              Se escolher o tipo errado, o Slack pode receber a mensagem, mas o Workflow Builder não conseguirá usar as variáveis.
            </SectionHeader>
            <div className="grid gap-4 lg:grid-cols-2">
              <div className="rounded-2xl border border-indigo-200 bg-indigo-50 p-5 dark:border-indigo-900/50 dark:bg-indigo-950/20">
                <Webhook className="h-6 w-6 text-indigo-700 dark:text-indigo-300" />
                <h3 className="mt-3 text-sm font-black uppercase tracking-widest text-indigo-950 dark:text-indigo-100">/triggers/ → Webhook Genérico</h3>
                <p className="mt-2 text-sm leading-7 text-indigo-900/80 dark:text-indigo-100/80">Escolha este tipo para Workflow Builder com ramificações e variáveis como status, uf, tempo e fonte_oficial.</p>
              </div>
              <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-5 dark:border-emerald-900/50 dark:bg-emerald-950/20">
                <MessageSquare className="h-6 w-6 text-emerald-700 dark:text-emerald-300" />
                <h3 className="mt-3 text-sm font-black uppercase tracking-widest text-emerald-950 dark:text-emerald-100">/services/ → Slack</h3>
                <p className="mt-2 text-sm leading-7 text-emerald-900/80 dark:text-emerald-100/80">Escolha este tipo para Incoming Webhook simples, quando o Monitor Fiscal envia a mensagem pronta para o canal.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <SectionHeader eyebrow="Mensagens prontas" title="Modelos para colar no Slack">
              Use estes modelos nas ações de enviar mensagem do Workflow Builder.
            </SectionHeader>
            <div className="grid gap-4 lg:grid-cols-3">
              {statusMessages.map(([status, message]) => (
                <article key={status} className="rounded-2xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-950/50">
                  <h3 className="text-sm font-black text-gray-950 dark:text-white">{status}</h3>
                  <div className="mt-3">
                    <CodeBlock>{message}</CodeBlock>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <SectionHeader eyebrow="Payload" title="Payload completo de disponibilidade">
              No Webhook Genérico, os principais campos são enviados no topo do JSON para o Workflow Builder conseguir ler. Quando o evento é de disponibilidade, <code>event</code> vem como <code>service_availability</code>.
            </SectionHeader>
            <div className="mt-5">
              <CodeBlock>{workflowPayload}</CodeBlock>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <SectionHeader eyebrow="Payload" title="Payload completo de novo documento">
              Quando o evento é de documento novo, <code>event</code> vem como <code>new_document</code>.
            </SectionHeader>
            <div className="mt-5">
              <CodeBlock>{documentPayload}</CodeBlock>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <SectionHeader eyebrow="Tópicos" title="Eventos disponíveis para selecionar">
            Disponibilidade serve para queda, instabilidade e normalização. Novos documentos serve para publicações técnicas.
          </SectionHeader>
          <div className="grid gap-4 lg:grid-cols-2">
            <TopicList title="Disponibilidade de serviço" topics={serviceTopics} />
            <TopicList title="Novos documentos" topics={documentTopics} />
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <SectionHeader eyebrow="Campos" title="Tabela de variáveis para Workflow Builder">
            Crie as variáveis com estes nomes para poder montar mensagens e condições no Slack.
          </SectionHeader>
          <FieldTable />
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <SectionHeader eyebrow="Propriedades" title="Campos do payload service_availability">
            Use esta tabela como contrato operacional para saber o tipo, os valores possíveis e o uso de cada propriedade.
          </SectionHeader>
          <PropertyTable rows={servicePayloadProperties} />
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <SectionHeader eyebrow="Propriedades" title="Campos dentro de data para disponibilidade">
            O objeto <code>data</code> preserva os dados técnicos usados para gerar o payload do Slack.
          </SectionHeader>
          <PropertyTable rows={serviceDataProperties} />
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <SectionHeader eyebrow="Propriedades" title="Campos do payload new_document">
            Estes campos aparecem quando o alerta é sobre publicação de novo documento fiscal.
          </SectionHeader>
          <PropertyTable rows={documentPayloadProperties} />
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <SectionHeader eyebrow="Propriedades" title="Campos dentro de data para novo documento">
            O campo <code>url</code> aponta para o link público do Monitor Fiscal, enquanto <code>officialSourceUrl</code> preserva o link oficial original.
          </SectionHeader>
          <PropertyTable rows={documentDataProperties} />
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <SectionHeader eyebrow="Valores possíveis" title="Status, severidade e tipos">
            Para ramificações no Slack, o campo mais importante é <code>status</code>.
          </SectionHeader>
          <div className="grid gap-4">
            <ValueTable headers={['status', 'Quando usar']} rows={statusValueRows} />
            <ValueTable headers={['Grupo', 'status_raw possíveis']} rows={rawStatusRows} />
            <ValueTable headers={['severity', 'Significado']} rows={severityRows} />
            <ValueTable headers={['statusCode', 'status', 'status_raw', 'status_label', 'severity']} rows={statusCodeRows} />
            <ValueTable headers={['channelType', 'Quando usar']} rows={channelTypeRows} />
            <ValueTable headers={['event', 'Quando aparece']} rows={auxiliaryEventRows} />
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <SectionHeader eyebrow="Teste e permissões" title="Usuário final consegue testar?">
              Sim, desde que esteja usando uma API Key com escopo notifications. O servidor valida o escopo no cadastro, listagem, teste e remoção.
            </SectionHeader>
            <div className="grid gap-3 md:grid-cols-3">
              {[
                ['Admin', 'Pode cadastrar, listar, testar e remover webhooks com token administrativo.'],
                ['Usuário com notifications', 'Pode cadastrar, listar, testar e remover webhooks autorizados pelo escopo.'],
                ['Usuário sem notifications', 'Consegue abrir a tela, mas o servidor bloqueia as ações com erro de permissão.']
              ].map(([title, body]) => (
                <article key={title} className="rounded-2xl border border-gray-100 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-950/50">
                  <ShieldCheck className="h-5 w-5 text-indigo-600 dark:text-indigo-300" />
                  <h3 className="mt-3 text-sm font-black text-gray-950 dark:text-white">{title}</h3>
                  <p className="mt-2 text-xs leading-6 text-gray-600 dark:text-gray-300">{body}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 pb-8 lg:px-6">
          <SectionHeader eyebrow="Troubleshooting" title="Problemas comuns">
            Use esta seção para diagnosticar as dúvidas mais frequentes na configuração.
          </SectionHeader>
          <div className="grid gap-4 md:grid-cols-2">
            {troubleshootingItems.map(([title, body]) => (
              <article key={title} className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm dark:border-gray-800 dark:bg-gray-900">
                <HelpCircle className="h-5 w-5 text-indigo-600 dark:text-indigo-300" />
                <h3 className="mt-3 text-sm font-black text-gray-950 dark:text-white">{title}</h3>
                <p className="mt-2 text-sm leading-7 text-gray-600 dark:text-gray-300">{body}</p>
              </article>
            ))}
          </div>
        </section>

      </main>
    </div>
  );
}
